import { ApiResponse } from '@interfaces/api-response/1.0';

export enum RawLookupType {
  MODIFIER = 'MODIFIER',
  MODIFIER_GROUP = 'MODIFIER_GROUP',
  MODIFIER_CODE = 'MODIFIER_CODE',
  PRODUCT = 'PRODUCT',
  COMBO = 'COMBO',
  INSTRUCTION = 'INSTRUCTION',
}

export interface RawPosItem {
  tenantId: string;
  storeId: string;
  rawPosLookupType: RawLookupType;
  rawPosSku?: string;
  rawJson: any;
  description: string;
  rawPosValue?: string;
  price?: number;
}

export enum AbbreviatedItemLookupType {
  COMBO = 'C',
  MODIFIER = 'M',
  MODIFIER_CODE = 'MC',
  MODIFIER_GROUP = 'G',
  PRODUCT = 'I',
  INSTRUCTION = 'i',
  PRODUCT_RAW = 'P',
}

export enum AbbreviatedItemReverseLookupType {
  C = 'COMBO',
  M = 'MODIFIER',
  I = 'PRODUCT',
  i = 'INSTRUCTION',
  G = 'MODIFIER_GROUP',
  MC = 'MODIFIER_CODE',
  P = 'PRODUCT_RAW',
}

export interface RawPosItems extends ApiResponse {
  _embedded: {
    rawPosEntries: RawPosItem[];
  };
}

export interface PosItem extends RawPosItem, PosListItem {
  dataGroupName: string;
  dataGroupId: string;
}

export interface StatusOfRawPosItem {
  id: string;
  tenantId: string;
  storeId: string;
  dataGroupId: string;
  status: string;
}

export interface PosMenuExtract {
  jobId: string;
  url: string;
}

interface PosListItem {
  isMapped?: boolean;
  typeIndicator?: AbbreviatedItemLookupType;
}

export interface BulkPosConfigField {
  key: string;
  type: 'string' | 'number' | 'boolean' | 'select' | 'group' | 'object';
  label?: string;
  hint?: string;
  alwaysEnabled?: boolean;
  default?: string | number | boolean;
  required?: boolean;
  min?: number;
  max?: number;
  options?: string[];
  groupFields?: BulkPosConfigField[];
  objectFields?: BulkPosConfigField[];
}
